module.exports = __webpack_public_path__ + "img/藤井佑真.1642a825.png";